
import { Component, Mixins, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { validationMixin } from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";
import vselect3 from "vselect3";
import { isEqual } from "lodash";

import ChildDeviceEditMixin from "@/components/device-setup/editing/ChildDeviceEditMixin";
import { AudioSettingsMeta } from "@/store/devices/types";

const Devices = namespace("devices");

@Component({
	components: {
		"v-select-3": vselect3
	},
	validations: {
		device: { required },
		hasSettingsMetaChanged: {
			required: requiredIf(function() {
				return this.isEditing && isEqual(this.device.audioSettings, this.originalAudioSettings);
			})
		}
	}
})
export default class AudioEdit extends Mixins(ChildDeviceEditMixin, validationMixin) {
	private originalAudioSettings: AudioSettingsMeta = null;

	public created(): void {
		this.originalAudioSettings = { ...this.device.audioSettings };
	}
}
